import React, { useState } from "react";
import AnimateFromBottom from "../../LandingPage/component/AnimateFromBottom";
import language from "../../../helpers/language";
import howItWorkImg from "../../../assets/landing-page/how-it-work.png";

const HowItWorks = () => {
  const [lang] = useState(language.getLang());

  const steps = [
    { number: "01", title: lang?.howItWorks_step1_title, desc: lang?.howItWorks_step1_desc },
    { number: "02", title: lang?.howItWorks_step2_title, desc: lang?.howItWorks_step2_desc },
    { number: "03", title: lang?.howItWorks_step3_title, desc: lang?.howItWorks_step3_desc },
  ];

  return (
    <section className="md:px-14 px-4 md:py-14 py-10">
      <div className="relative max-w-6xl mx-auto overflow-hidden rounded-xl">
        <img
          src={howItWorkImg}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div
          className="relative z-10 md:px-8 px-4 py-12 md:py-16 flex flex-col justify-center"
          style={{ minHeight: "520px" }}
        >
          {/* Pill */}
          <AnimateFromBottom delay={0.1}>
            <div className="flex justify-center mb-6">
              <span className="inline-block bg-blue-400 text-white text-xs font-semibold px-10 py-2 rounded">
                {lang?.howItWorks_pill}
              </span>
            </div>
          </AnimateFromBottom>

          {/* Heading */}
          <AnimateFromBottom delay={0.2}>
            <h2 className="text-center text-gray-900 font-extrabold text-3xl md:text-5xl">
              {lang?.howItWorks_title}
            </h2>
          </AnimateFromBottom>

          {/* Step cards */}
          <div className="grid md:grid-cols-3 gap-5 mt-12">
            {steps.map(({ number, title, desc }, i) => (
              <AnimateFromBottom delay={0.3 + i * 0.1} key={number}>
                <div className="how--create--card bg-white border border-gray-200 rounded-md shadow-sm md:px-8 px-6 py-7 text-center h-full" style={{ minHeight: "165px" }}>
                  <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-5">
                    <span className="text-teal-600 font-bold text-base">{number}</span>
                  </div>
                  <h4 className="text-gray-900 font-bold text-sm md:text-base mb-3 leading-tight">
                    {title}
                  </h4>
                  <p className="text-gray-500  leading-snug">{desc}</p>
                </div>
              </AnimateFromBottom>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
